<div class="journey-progress-wheel">
  <img class="journey-progress-wheel-circle" src="{{ journeyWheelImagePath + wheelColor + '-' + percentage + '.svg' }}" />
  <img class="journey-progress-wheel-icon" src="{{ journeyInsideIconPath + journeyIconName }}" />
</div>
